<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useTitle } from '@vueuse/core';

useTitle('Server Error');

const route = useRoute();

const customMessage = computed(() => route.query.message as string | undefined);

const error = computed(() => ({
  statusCode: 500,
  statusMessage: 'Server error',
  message: customMessage.value || 'Something went wrong. Please try again later.',
}));
</script>

<template>
  <UError
    :error="error"
    :clear="false"
  >
    <template #links>
      <RouterLink :to="{ name: 'Home' }">
        <UButton
          size="lg"
          color="primary"
          label="Go home"
        />
      </RouterLink>
    </template>
  </UError>
</template>
